import { render, staticRenderFns } from "./LinkBlock.vue?vue&type=template&id=b57ed7ca&"
import script from "./LinkBlock.ts?vue&type=script&lang=ts&"
export * from "./LinkBlock.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports